import GridConnectionCardSkeleton from '@/modules/charge-center/skeleton-components/grid-connection-card-skeleton';
import { Skeleton } from '@/shared/components/ui/skeleton';

const GridConnectionsMonitorSkeleton = () => {
  return (
    <div className="asset-gc-list $tw-mt-6 $tw-space-y-6">
      {Array.from({ length: 2 }).map((_, assetIndex) => (
        <div
          key={assetIndex}
          className="$tw-rounded-md $tw-border $tw-border-foreground/50 $tw-bg-foreground/5 $tw-p-4 xl:$tw-px-10"
        >
          <div className="$tw-mb-4 $tw-flex $tw-w-full $tw-items-center $tw-justify-between $tw-gap-2">
            <div className="$tw-flex $tw-flex-col $tw-justify-center $tw-gap-1">
              <Skeleton className="$tw-h-5 $tw-w-44" />
              <Skeleton className="$tw-h-4 $tw-w-64" />
            </div>
            <Skeleton className="$tw-hidden $tw-h-5 $tw-w-24 md:$tw-flex" />
          </div>
          <GridConnectionCardSkeleton />
        </div>
      ))}
    </div>
  );
};

export default GridConnectionsMonitorSkeleton;
